import type { ReactElement } from 'react';
import * as React from 'react';
import LockImage from '@hotjar/shared-assets/images/lock.png';
import { GuideCard } from '@hotjar/activation-toolkit';
import { Button, Stack } from '@hotjar/hotsauce';
import { useDismiss } from '@hotjar/webapp/hooks/useDismiss';
import { useTranslationWithPrefix } from '@hotjar/translations';
import { useMfaModals } from '@hotjar/webapp/features/Mfa/useMfaModals';
import { useCurrentUser } from '@hotjar/user';
import { useMfaSettings } from '@hotjar/webapp/domains/mfa';
import { BannerWrapper, LockImageWrapper } from './style';

const APP_STATE_NAMESPACE = 'ACCOUNT_SECURITY_PAGE';

export const MfaBanner = (): ReactElement | null => {
  const { t } = useTranslationWithPrefix('mfa:mfa-banner');
  const { isDismissed, dismiss } = useDismiss(APP_STATE_NAMESPACE, 'Activate-Mfa');
  const { setEnableMfa } = useMfaModals();
  const { data: user } = useCurrentUser();
  const { data: mfaSettings } = useMfaSettings(user?.id);
  const isMfaEnabled = mfaSettings?.enabled ?? false;

  if (isDismissed || isMfaEnabled) {
    return null;
  }

  return (
    <BannerWrapper>
      <GuideCard
        onDismiss={dismiss}
        label={t('caption')}
        title={t('title')}
        description={t('description')}
        media={
          <LockImageWrapper>
            <img src={LockImage} alt="Enable MFA" />
          </LockImageWrapper>
        }
        actions={
          <Stack direction="row">
            <Button as="button" kind="secondary" onClick={() => setEnableMfa(true)}>
              {t('enable-mfa')}
            </Button>
          </Stack>
        }
      />
    </BannerWrapper>
  );
};
